import React from "react";
import { AddCommaNumber } from "../../../helpers/Utils";
import IntlMessages from "../../../helpers/IntlMessages";

const ProviderKPISummary = ({ dataAll = [] }) => {
  // Helper to calculate totals client-side
  const getTotals = (item) => {
    const items = item.company_provider_item || [];
    const income = items.reduce((acc, curr) => acc + (parseFloat(curr.price_income) || 0), 0);
    const outcome = items.reduce((acc, curr) => acc + (parseFloat(curr.price_outcome) || 0), 0);
    const pending = items.reduce((acc, curr) => acc + (parseFloat(curr.price_pending) || 0), 0);
    return { income, outcome, pending };
  };

  const totalProviders = dataAll.length;
  
  const totalDebt = dataAll.reduce((acc, curr) => {
    const { pending } = getTotals(curr);
    return acc + pending;
  }, 0);

  const paidCount = dataAll.filter((x) => {
    const { income, outcome } = getTotals(x);
    return income > 0 && outcome === income;
  }).length;

  const debtCount = dataAll.filter((x) => {
    const { pending } = getTotals(x);
    return pending > 0;
  }).length;

  // const noTransCount = dataAll.filter((x) => {
  //   const { income } = getTotals(x);
  //   return income === 0;
  // }).length;


  const kpis = [
    {
      id: "total",
      label: "provider.kpi.total",
      value: totalProviders,
      icon: "simple-icon-people",
      class: "total-provider",
      trend: "+12%",
      trendClass: "up",
    },
    {
      id: "debt",
      label: "provider.kpi.total-debt",
      value: `${AddCommaNumber(totalDebt)}đ`,
      icon: "simple-icon-wallet",
      class: "total-debt",
      trend: "-8%",
      trendClass: "down",
    },
    {
      id: "paid",
      label: "provider.kpi.paid",
      value: paidCount,
      icon: "simple-icon-check",
      class: "paid",
      trend: "+15%",
      trendClass: "up",
    },
    {
      id: "in-debt",
      label: "provider.kpi.in-debt",
      value: debtCount,
      icon: "simple-icon-close",
      class: "in-debt",
      trend: "+5%",
      trendClass: "up",
    },
    // {
    //   id: "no-trans",
    //   label: "provider.kpi.no-transaction",
    //   value: noTransCount,
    //   icon: "simple-icon-doc",
    //   class: "no-trans",
    //   trend: "+2%",
    //   trendClass: "up",
    // },
  ];

  return (
    <div className="kpi-summary-row">
      {kpis.map((kpi) => (
        <div className="kpi-card-col" key={kpi.id}>
          <div className="kpi-card">
            <div className="kpi-card-header">
              <div className={`kpi-icon-wrapper ${kpi.class}`}>
                <i className={kpi.icon} />
              </div>
              <div className="kpi-card-content">
                <span className="kpi-card-title">
                  <IntlMessages id={kpi.label} />
                </span>
                <span className="kpi-card-value">{kpi.value}</span>
              </div>
            </div>
            {/* <div className={`kpi-card-trend ${kpi.trendClass}`}>
              <span className="trend-percent">{kpi.trend}</span>
              <span className="trend-lbl">so với tháng trước</span>
            </div> */}
          </div>
        </div>
      ))}
    </div>
  );
};

export default React.memo(ProviderKPISummary);
